
import errorMessage from 'Store/actions/errorMessage';
import axios from 'axios';
import { GET_HORSE_RACING_UPCOMING_RACES, GET_HORSE_RACING_UPCOMING_RACES_FAILURE, GET_HORSE_RACING_UPCOMING_RACES_SUCCESS } from 'Store/constants';
import { upcomingRacesMapper } from 'Utils/horseRacesNameMapper';
import { catchTJKError } from 'Utils/catchTJKError';
import ProjectConfig from 'ProjectConfig';

export const getUpcomingRaces = () => async dispatch => {
  try {
    dispatch({
      type: GET_HORSE_RACING_UPCOMING_RACES,
    });
    
    const apiUrl = ProjectConfig.API_GATEWAY + '/mobile/tjk/upcoming-races';
    const res = await axios.get(apiUrl);

  
    const payload = upcomingRacesMapper(res.data.body);

    catchTJKError(res.data);

    dispatch({
      type: GET_HORSE_RACING_UPCOMING_RACES_SUCCESS,
      payload: payload
    });
      
  } catch (e) {
      
    dispatch({
      type: GET_HORSE_RACING_UPCOMING_RACES_FAILURE,
      payload: (e.response && e.response.data) || errorMessage,
    });
  }
};